import { SpaceSwitcher } from "@octopusdeploy/main-navigation";
import { AnalyticLinkLocationProvider } from "@octopusdeploy/portal-analytics";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import AddSpaceDialogLayout from "~/areas/configuration/components/Spaces/AddSpaceDialogLayout";
import Dialog from "~/components/Dialog/Dialog";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { isSpecificSpaceContext } from "~/components/SpaceLoader/SpaceLoader";
import type { SpaceContext } from "~/components/SpaceLoader/SpaceLoader";
interface SpaceSwitcherUpliftProps {
    spaceContext: SpaceContext;
}
export function SpaceSwitcherNavigationBarItem({ spaceContext }: SpaceSwitcherUpliftProps) {
    const navigation = useSpaceAwareNavigation();
    const { isOpen: isAddSpaceDialogOpen, openDialog: openAddSpaceDialog, closeDialog: closeAddSpaceDialog } = useDialogTrigger();
    const currentSpace = isSpecificSpaceContext(spaceContext) ? spaceContext : undefined;
    return (<AnalyticLinkLocationProvider location={"Space Switcher"}>
            <SpaceSwitcher currentSpace={currentSpace} onNewSpaceRequested={openAddSpaceDialog}/>
            <Dialog open={isAddSpaceDialogOpen}>
                <AddSpaceDialogLayout onSpaceCreated={(space) => {
            closeAddSpaceDialog();
            navigation.navigate(links.spacePage.generateUrl({ currentSpaceId: space.Id }));
        }}/>
            </Dialog>
        </AnalyticLinkLocationProvider>);
}
